<!-- Modals -->
<app-deprecated-modal-form
    #filterModal
    headerText="reporting.payroll.filterResults"
    [form]="filterForm"
    (save)="onFilter(filterForm.dates, filterForm.includePending, filterForm.jurisdiction)"
>
    <app-form-filter-payroll-report
        [schedule]="schedule"
        [report]="reportInterface"
        [reportStartAt]="startAt"
        [reportEndAt]="endAt"
        [jurisdictionFilter]="true"
        [jurisdictions]="jurisdictions"
        [jurisdiction]="jurisdiction"
        #filterForm
    ></app-form-filter-payroll-report>
</app-deprecated-modal-form>

<div class="ui basic segment" [class.loading]="isLoading">
    <!-- Makes sure the buttons are aligned nicely with the app header -->
    <div class="combined-header">
        <app-header [title]="reportInterface.name" [back]="displayBackRoute"></app-header>

        <!-- Filter and Export Buttons -->
        <div class="button-container" [class.no-back-route]="!displayBackRoute">
            <ui-button *ngIf="reportInterface?.filterable" (click)="filterModal.show()" type="outline"
                >{{ 'filter' | translate }}
            </ui-button>

            <div class="ui compact menu">
                <div class="ui simple dropdown item">
                    {{ 'export' | translate }}
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <div class="item" (click)="exportCSV()">
                            {{ 'reporting.payroll.workersCompensation.csvBasicReport' | translate }}
                        </div>
                        <div class="item" (click)="exportPerLineItemCSV()">
                            {{ 'reporting.payroll.workersCompensation.csvLineItemReport' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="report">
        <!-- show date filter results for filterable reports -->
        <ng-container *ngIf="reportInterface?.filterable">
            <div class="date-information">
                <div *ngIf="isSingleDayRange">
                    <span class="label-text">{{ 'reporting.payroll.chequeDate' | translate }}</span
                    ><span class="meta-value">: {{ startAt | appDate: 'yyyy/MM/dd' }}</span>
                </div>
                <div *ngIf="!isSingleDayRange">
                    <span class="label-text">{{ 'reporting.payroll.dateRange' | translate }}</span
                    ><span class="meta-value"
                        >: {{ startAt | appDate: 'yyyy/MM/dd' }} - {{ endAt | appDate: 'yyyy/MM/dd' }}</span
                    >
                </div>
                <div
                    *ngIf="reportInterface?.allowsInclusionOfPendingPayrolls && filterForm.includePending"
                    class="payroll-in-progress"
                >
                    {{ 'reporting.payroll.includesPendingPayroll' | translate }}
                </div>
            </div>
        </ng-container>

        <!-- Table -->
        <div class="ui table form segment" *ngIf="report.sheet">
            <table *ngIf="report.sheet.rows.length" class="ui unstackable table">
                <thead>
                    <tr>
                        <th
                            *ngFor="let column of report.sheet.columns; trackBy: trackByFn"
                            class="top-sticky"
                            [class.left-sticky]="column.sticky"
                        >
                            {{ column.title }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of report.sheet.rows; trackBy: trackByFn">
                        <td
                            *ngFor="let cell of row.cells; trackBy: trackByFn"
                            [class.left-sticky]="stickyColumns.includes(cell.column)"
                            [class.last-left-sticky]="cell.column === lastStickyColumn"
                        >
                            <span *ngIf="cell.value; else displayDash"> {{ cell.value }} </span>
                            <ng-template #displayDash>
                                <span>-</span>
                            </ng-template>
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- Empty state -->
            <div class="empty-state" *ngIf="!report.sheet.rows.length">
                <img src="/assets/illustrations/documents.png" />
                <div>{{ 'reporting.payroll.noRecordsForDateRange' | translate }}</div>
            </div>
        </div>
    </ng-container>
</div>
